import React, { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { ALPHANUMERIC_REGEX } from '../../../validators/InputValidator';
import { REGISTER_COMPANIES } from '../../../config/PermissionTypes';
import { getCompanies } from "../../../service/RegisterCompaniesService";
import Has from '../../../component/Permission/Has';
import LoadingSpinner from '../../../component/LoadingSpinner/LoadingSpinner';
import "./Register.css";
import { COMPANY_DETAILS_SIDE_PANEL } from './../../../config/SidePanelTypes';
import SidePanel from './../../../component/SidePanel/SidePanel';


// const customSelectStyles = {
//     menu: (provided) => ({
//         ...provided,
//         marginTop: '5px'
//     }),
//     option: (styles, { isFocused }) => {
//         return {
//             ...styles,
//             backgroundColor: isFocused ? '#00b5e2' : undefined,
//             color: '#333333'
//         }
//     },
//     control: (styles, { isDisabled, isFocused, isSelected }) => {
//         return {
//             ...styles,
//             boxShadow: isFocused ? '0 0 0 1px #00b5e2' : undefined,
//             borderColor: isDisabled
//                 ? undefined
//                 : isSelected && !isFocused
//                     ? '#00b5e2'
//                     : isFocused
//                         ? '#00b5e2'
//                         : '#D3D6DE',
//             ':hover': {
//                 borderColor: '#00b5e2',
//             }
//         }
//     }
// }


export default function RegisterCompanies(props) {
    const [allCompanies, setAllCompanies] = useState([]);   //this will be master list that can be filtered & searched from
    const [companies, setCompanies] = useState([]);
    const [currentCompany, setCurrentCompany] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [sortColumn, setSortColumn] = useState("name");
    const [sortDirection, setSortDirection] = useState("desc");
    const [searchValue, setSearchValue] = useState("");
    const [selectedStatus, setSelectedStatus] = useState({ label: 'All', value: 'all' });
    // const companyStatusOptions = [
    //     { label: 'All', value: 'all' },
    //     { label: 'Active', value: true },
    //     { label: 'Inactive', value: false }
    // ];
    const navigate = useNavigate();

    let isEditClicked = false;
    function onRowSelect(company) {
        if (isEditClicked === true) {
            isEditClicked = false;
        } else {
            setCurrentCompany(company);
            setIsModalOpen(true);
        }
    }

    function onEditLink() {
        isEditClicked = true;
    }

    // const handleStatusChange = (status) => {
    //     setSelectedStatus(status);
    //     applyFilters(searchValue, status.value);
    // }

    const handleSearchChange = (value) => {
        const regex = new RegExp(ALPHANUMERIC_REGEX);
        if (regex.test(value)) {
            setSearchValue(value);
            applyFilters(value, selectedStatus.value);
        }
    }

    const applyFilters = (searchValue, statusValue) => {
        let companies = allCompanies;
        if (searchValue !== "") {
            searchValue = searchValue.toLowerCase();
            companies = companies.filter(company => company.companyName.toLowerCase().includes(searchValue) || company.companyNumber.includes(searchValue));
        }
        if (statusValue !== "all") {
            companies = companies.filter(company => company.is_active === statusValue);
        }
        setCompanies(companies);
    }

    //this sets the sort icon of the currently sorted column
    const iconClass = (column) => {
        const dir = sortColumn === column ? `_${sortDirection}ending` : '';
        return "cb-icon icon-sort" + dir;
    }

    const setSort = (column) => {
        let direction = 'desc';
        if (column) {
            if (column !== sortColumn) {
                setSortColumn(column);
                setSortDirection(direction);
            } else {
                direction = sortDirection === 'desc' ? 'asc' : 'desc';
                setSortDirection(direction)
            }
        }
        const val = direction === "asc" ? 1 : -1;
        companies.sort((a, b) => (b[column].toString().localeCompare(a[column].toString())) * val);
    }

    const errorHandler = (error) => {
        if (error?.response?.status !== 200) {
            setHasError(true);
            setAllCompanies([]);
            setCompanies([]);
        } else {
            setHasError(false);
        }
        setIsLoading(false);
    }

    const dataHandler = (companyData) => {
        setIsLoading(false);
        //initially sort Companies by name
        const companies = companyData.sort((a, b) => a.companyName.localeCompare(b.companyName));
        setAllCompanies(companies);
        setCompanies(companies);
    }

    useEffect(() => {
        getCompanies(dataHandler, errorHandler);
    }, []);

    const columnHeaders = [{ display: "Company Name", value: "companyName" },
    { display: "Company Number", value: "companyNumber" },
    { display: "Registered Date", value: "registeredDate" },
    { display: "Last Modified Date", value: "lastModifiedDate" },
    // {display:"Status", value:"is_active"}, will be added later
    { display: "Modified By", value: "modifiedBy" }];


    return (
        <React.Fragment>
            <Has isPageLevel={true} permission={REGISTER_COMPANIES}>
                {/* <!-- Page content--> */}
                <div className="container-fluid" data-testid="register-companies-page" id="register-companies-page">

                    <div className="page-title-area">
                        <h1 data-testid='register-companies-page-header-title'>Registered Companies</h1>
                    </div>

                    <div className="row register-companies-table-runner">
                        <div className="col-md-6 register-companies-filters">
                            {/* will be used later
                            <div>
                                <div className="sectionTitle" data-testid="filter-companies-label">Filter Companies</div>
                                <Select
                                    className="cb-multiselect cb-form"
                                    components={{
                                        IndicatorSeparator: () => null,
                                        Control,
                                    }}
                                    customProps={{ selectLabel: "Status:", selectType: "is_active" }}
                                    isSearchable={false}
                                    onChange={handleStatusChange}
                                    options={companyStatusOptions}
                                    styles={customSelectStyles}
                                    value={selectedStatus}
                                />
                            </div> */}
                            <div>
                                <div className="sectionTitle" data-testid="search-companies-label">Search Companies</div>
                                <div className="company-search-container">
                                    <input className='cb-form-control'
                                        type="text"
                                        data-testid="company-search-input"
                                        maxLength="256"
                                        onChange={e => handleSearchChange(e.target.value)}
                                        placeholder="Name or Number"
                                        value={searchValue}
                                    />
                                    <i className="cb-icon icon-search"></i>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <Has permission={REGISTER_COMPANIES}>
                                <div className="add-company-button-container">
                                    <button
                                        type="button"
                                        className="cb-btn add-company-button d-lg-block"
                                        data-testid="add-company-button"
                                        onClick={() => navigate('/system/registerCompany')}
                                    >
                                        + Register Company
                                    </button>
                                </div>
                            </Has>
                        </div>
                    </div>

                    {isLoading ? (
                        <div className="company-message" data-testid="companies-loading">
                            <LoadingSpinner blue size={50} />
                            <p className='text-center'>Loading company data...</p>
                        </div>
                    ) : null}
                    {!isLoading && hasError ? (
                        <div className="company-message">
                            <h3 className="text-center" data-testid="company-data-error">An error occurred getting company data.</h3>
                        </div>
                    ) : null}
                    {!isLoading && !hasError && !companies.length ? (
                        <div className="company-message">
                            <h3 className="text-center" data-testid="company-data-no-results">No company results found.</h3>
                        </div>
                    ) : null}
                    {!isLoading && !hasError && companies.length ? (
                        <div className="cb-table-responsive company-table">
                            <table className="table table-sort table-arrows cb-table">
                                <thead className="table-light thead">
                                    <tr>
                                        {columnHeaders.map(item => {
                                            return <th tabIndex={0} onKeyDown={({ key }) => key === "Enter" ? setSort(item.value) : ""}>
                                                <span onClick={() => setSort(item.value)} id={`company-table-${item.value}-header`} data-testid={`company-table-${item.value}-header`}>
                                                    {item.display} <i className={iconClass(item.value)}></i>
                                                </span>
                                            </th>
                                        })}
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {companies.map((company, index) => {
                                        return (
                                            <tr key={`company-row-${index}`} onClick={() => onRowSelect(company)} tabIndex={0} onKeyDown={({ key }) => key === "Enter" ? onRowSelect(company) : ""}>
                                                <td data-testid={`company-table-company-name-${company.companyNumber}`}>{company.companyName}</td>
                                                <td data-testid={`company-table-company-number-${company.companyNumber}`}>{company.companyNumber}</td>
                                                <td data-testid={`company-table-company-registered-date-${company.companyNumber}`}>{company.registeredDate}</td>
                                                <td data-testid={`company-table-company-last-modified-date-${company.companyNumber}`}>{company.lastModifiedDate}</td>
                                                {/* <td><span className={`status ${company.is_active ? 'active' : 'inactive'}`}>&nbsp;</span>{company.is_active ? 'Active' : 'Inactive'}</td> */}
                                                <td>{company.modifiedBy}</td>
                                                {<td className="text-right">
                                                    <Has permission={REGISTER_COMPANIES}>
                                                        <Link onKeyDown={({ key }) => key === "Enter" ? onEditLink(company) : ""}
                                                            className="edit-cell"
                                                            to={`/system/registerCompany/${company.companyNumber}/edit`}
                                                            data-testid={`edit-company-link-${company.companyNumber}`}
                                                            state={{ uuid: company.uuid, companyNumber: company.companyNumber }} >
                                                            <i className="cb-icon icon-edit"></i>
                                                            <span>Edit</span>
                                                        </Link>
                                                    </Has>
                                                </td>}
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                            <SidePanel
                                isModalOpen={isModalOpen}
                                setIsModalOpen={setIsModalOpen}
                                sidePanelType={COMPANY_DETAILS_SIDE_PANEL}
                                company={currentCompany} />
                        </div>
                    ) : null}
                </div>
            </Has>
        </React.Fragment>
    );
}